import { render, staticRenderFns } from "./CalendarInfoDetail.vue?vue&type=template&id=9bbd2696&scoped=true&"
import script from "./CalendarInfoDetail.vue?vue&type=script&lang=js&"
export * from "./CalendarInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CalendarInfoDetail.vue?vue&type=style&index=0&id=9bbd2696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbd2696",
  null
  
)

export default component.exports